/**
	Функция которая запоминает в сессию объект содержащий готовые гет-параметры поиска и мапу со значениями для фильтра
	Ключ сессии содержит в себе арм, вп и цепочку дочерних и родительских АРМ
*/

var filtermem = {
	get: function(armId, vpId, childPath) {
		var storageKey = getStorageKey(armId, vpId, childPath);
		var res = null;
		var stored = JSON.parse(window.sessionStorage.getItem(storageKey));
		return (stored && stored['valuesMap'] && stored['queryString']) ? stored : null;
	},
	set: function(armId, vpId, childPath, queryString, valuesMap) {		
		var storageKey = getStorageKey(armId, vpId, childPath);
		window.sessionStorage.setItem(storageKey, JSON.stringify({
			queryString,
			valuesMap
		}))
	},
	flush: function(armId, vpId, childPath) {
		var storageKey = getStorageKey(armId, vpId, childPath);
		window.sessionStorage.removeItem(storageKey);
	},
}

function getStorageKey(armId, vpId, childPath) {
	var childPathStrArr = [];
	for (var i = 0; i < childPath.length; i++) {
		childPathStrArr.push('arm-' + childPath[i].armId + (childPath[i].parentRecordId ? ('_rec-' + childPath[i].parentRecordId) : ''));
		// итоговое значение в дочернем АРМ будет &childPath=arm-123,arm-456_rec-789
		// то есть у нас открыт дочерний АРМ 456, айди родительской записи 789, а айди родительского АРМ где эта запись была - 123
	}
	return 'filtermem:arm=' + armId + '&vp=' + vpId + '&childPath=' + childPathStrArr.join();
}

export default filtermem;